<mat-icon #toggleIntercom (click)="handleToggleIntercom()" [svgIcon]="isShow ? 'arrow_upward' : 'contact_support'"> </mat-icon>
